import { make } from "vuex-pathify"

const state = {
  dialogIsFullPage: false
};

const mutations = make.mutations(state);


export default {
  namespaced: true,
  state,
  mutations
}